import Header from '@/components/common/Header';
import { Modal } from '@/components/common/Modal';
import { TabItem, Tabs } from '@/components/ui/tab';
import { X } from 'lucide-react';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import CreateAccessControl from './components/CreateAccessControl';
import { usePermissions } from '@/context/PermissionContext';

const RolesAndPrivileges = () => {
  const { hasModuleAccess } = usePermissions();
  const canCreate = hasModuleAccess('Roles-Privileges', 'create');

  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab =
    location.pathname.split('/').pop() === 'roles-and-privileges'
      ? 'roles'
      : (location.pathname.split('/').pop() ?? 'roles');
  const managementTabs: TabItem[] = [
    {
      id: 'roles',
      label: 'Roles',
      path: '/roles-and-privileges',
      img: '/images/contentManagement/banner.svg',
    },
    {
      id: 'access',
      path: '/roles-and-privileges/access',
      label: 'Access Control',
      img: '/images/contentManagement/notification.svg',
    },
  ];
  const handleTabChange = (id: string) => {
    if (id === 'roles') navigate('/roles-and-privileges');
    else navigate(`/roles-and-privileges/access`);
  };
  const onCancel = () => setOpenModal(false);

  return (
    <div className="padding">
      <Header
        title="Roles and Privileges"
        // count={'Manage banners, notifications, support contacts'}
        showButton={canCreate}
        buttonLabel={activeTab === 'roles' ? `+Add ${activeTab} ` : 'Create User'}
        onButtonClick={() =>
          activeTab === 'roles' ? navigate('/create-roles') : setOpenModal(true)
        }
      />

      <Tabs
        tabs={managementTabs}
        className="flex gap-1 rounded-xl p-1 w-fit my-3"
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <Outlet />
      <Modal
        open={openModal}
        onOpenChange={() => setOpenModal(false)}
        title={'Create User'}
        closeBtn={<X />}
        fullWidth={activeTab === 'Notification'}
        style="overflow-visible"
      >
        {activeTab === 'access' && <CreateAccessControl onCancel={onCancel} />}
      </Modal>
    </div>
  );
};

export default RolesAndPrivileges;
